import React, { useState, useEffect } from "react";
import { List, Modal, notification } from "antd";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import axios from "axios";
import { DragHandle } from "../../../../components/DragHandle";

const FaqOrdering = ({ isOpen, onClose, datas, moduleName, isMobile, base_url }) => {
  const [datalist, setDatalist] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setDatalist(datas);
  }, [datas]);

  const handleOrder = async (updatedData) => {
    setLoading(true);

    try {
      // Prepare the array for backend: _id + new position
      const orderPayload = updatedData.map((item, index) => ({
        _id: item._id,
        position: index,
      }));

      const response = await axios.post(`${base_url}/reorder`, { order: orderPayload });
      const data = response.data;

      if (data) {
        notification.success({
          message: `${moduleName} Sorting Updated Successfully`,
        });
        onClose();
      }
    } catch (err) {
      notification.error({
        message: "Failed to update sorting",
        description: err.message,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Ordering"
      visible={isOpen}
      onOk={() => handleOrder(datalist)}
      okText="Update"
      confirmLoading={loading}
      onCancel={onClose}
      width={600}
    >
      <DragDropContext
        onDragEnd={(result) => {
          const srcIndex = result.source.index;
          const destIndex = result.destination?.index;

          if (destIndex === undefined) return;

          const tempArray = [...datalist];
          tempArray.splice(destIndex, 0, tempArray.splice(srcIndex, 1)[0]);
          setDatalist(tempArray);
        }}
      >
        <Droppable droppableId="droppable-faq">
          {(provided) => (
            <div
              ref={provided.innerRef}
              {...provided.droppableProps}
              style={{ maxHeight: 400, overflowY: "auto" }}
            >
              <List
                bordered
                dataSource={datalist}
                renderItem={(item, index) => (
                  <Draggable key={item._id} draggableId={item._id} index={index}>
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        style={{
                          ...provided.draggableProps.style,
                          boxShadow: snapshot.isDragging ? "0 0 .4rem #666" : "none",
                          marginBottom: 8,
                        }}
                      >
                        <List.Item>
                          <span>{item.title}</span>
                          <DragHandle {...provided.dragHandleProps} />
                        </List.Item>
                      </div>
                    )}
                  </Draggable>
                )}
              />
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </Modal>
  );
};

export default FaqOrdering;
